import ApiService from './ApiService'

export const getApiPermissionData = () => ApiService.get('/user_service/admin-user/permissions/')
export const getApiGroupPermissionData = id => ApiService.get(`/user_service/admin-user/role/${id}/`)
export const assignPermissionApi = data => ApiService.post('/user_service/admin-user/group-permissions/', data)
export const removePermissionApi = data => ApiService.delete(`/user_service/user/group-permissions/`, data)
